import axios from '@/api/axios';
import i18n from '@/api/i18n/i18n';

import { openToast, TOAST_TYPE } from '@/utils/open-toast';

const getSettings = async (link) => {
  const response = await axios.post(link);
  if (response.data.success) {
    return response;
  }
  openToast(response.data.message, TOAST_TYPE.ERROR);
  response.data = null;
  return response;
};

export function getAllSettings(id, type) {
  return getSettings(`/settings/?id=${id}&type=${type}`);
}
export function getNeiroSett(id, type) {
  return getSettings(`/settings/neiroSett/?id=${id}&type=${type}`);
}

export const getSecRules = (profileId) => {
  return getSettings(`/settings/secRules/?profileId=${profileId}`);
};

export const delSecRuleMixquery = (id) => axios.post(`/settings/deleteSecRule/?id=${id}`);

export function getLogSettings(id, type) {
  return getSettings(`/settings/log/?id=${id}&type=${type}`);
}

export function getCommonSettings(id, type) {
  return getSettings(`/settings/common/?id=${id}&type=${type}`);
}

export function getScreenshotSettings(id, type) {
  return getSettings(`/settings/screenshot/?id=${id}&type=${type}`);
}
export function getScreenshotApps(id, type) {
  return getSettings(`/settings/screenApps/?id=${id}&type=${type}`);
}

export function getIdleSettings(id, type) {
  return getSettings(`/settings/idle/?id=${id}&type=${type}`);
}

export function getShadowCopySettings(id, type) {
  return getSettings(`/settings/shadow/?id=${id}&type=${type}`);
}

export function getFileSettings(id, type) {
  return getSettings(`/settings/files/?id=${id}&type=${type}`);
}

export function getDriveSettings(id, type) {
  return getSettings(`/settings/drives/?id=${id}&type=${type}`);
}

export function getInetSettings(id, type) {
  return getSettings(`/settings/internet/?id=${id}&type=${type}`);
}

export function getWebcamSettings(id, type) {
  return getSettings(`/settings/webcam/?id=${id}&type=${type}`);
}

export function getNotificationSettings(id, type) {
  return getSettings(`/settings/notifSett/?id=${id}&type=${type}`);
}

export function getCriticalEvents(id, type) {
  return getSettings(`/settings/criticalEvents/?id=${id}&type=${type}`);
}

export function getWatermarkSettings(id, type) {
  return getSettings(`/settings/watermarks/?id=${id}&type=${type}`);
}

export function getMeetings(id, dateFrom, dateTo) {
  return getSettings(`/settings/meetings?id=${id}&dateFrom=${dateFrom}&dateTo=${dateTo}`);
}

export const getMeetingsTypes = () => axios.get('/settings/meetingsTypes');

export const saveNewMeeting = (params) => axios.post('/settings/saveNewMeeting', params);

export const deleteMeeting = (id) => axios.post(`/settings/deleteMeeting/?id=${id}`);

export const changeMeeting = (params) => axios.post('/settings/changeMeeting', params);

export const saveNewMeetingType = (name) => axios.post(`/settings/saveNewMeetingType/?name=${name}`);

export const deleteMeetingType = (id) => axios.post(`/settings/deleteMeetingType/?id=${id}`);

export const renameMeetingType = (id, name) => axios.post(`/settings/renameMeetingType/?id=${id}&name=${name}`);

export function getGeneralSettings() {
  return axios.get('/settings/general').then(({ data }) => data);
}

export function getSearchType() {
  return axios.get('/settings/searchType').then(({ data }) => data);
}

export function getGenSettings() {
  return axios.get('/settings/generalSettings').then(({ data }) => data);
}

export function getMaxUsers() {
  return axios.get('/settings/maxUsers').then(({ data }) => data);
}

export function getMaxComputers() {
  return axios.get('/settings/maxComputers').then(({ data }) => data);
}

export function getProfiles() {
  return axios.get('/settings/profiles').then(({ data }) => data);
}

export function getCompRemote() {
  return axios.get('/settings/remote').then(({ data }) => data);
}

export function setProfileForPC(profId, compId) {
  return axios.post(`/settings/userProfile/?profId=${profId}&compId=${compId}`).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.userProfileSuccessfullyUpdated'));
    } else {
      openToast(response.data.message, TOAST_TYPE.ERROR);
    }
  });
}

export function setProfileForDep(profId, depId) {
  return axios.post(`/settings/groupProfile/?profId=${profId}&depId=${depId}`).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.groupProfileSuccessfullyUpdated'));
    } else {
      openToast(response.data.message, TOAST_TYPE.ERROR);
    }
  });
}

export function addProfile(name, baseId) {
  return axios.post(`/settings/newProfile/?name=${name}&baseId=${baseId}`).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.profileSuccessfullyAdded'));
      return TOAST_TYPE.SUCCESS;
    }

    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}

export function saveProfiles(added, removed) {
  return axios.post('/settings/saveProfiles', { added, removed }).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.changesSuccessfullySaved'));
      return TOAST_TYPE.SUCCESS;
    }

    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}

export function deleteProfile(id) {
  if (id !== 1) {
    return axios.post(`/settings/deleteProfile/?id=${id}`).then((response) => {
      if (response.data.success) {
        openToast(i18n.t('toast.profileSuccessfullyDeleted'));
      } else {
        openToast(response.data.message, TOAST_TYPE.ERROR);
      }
    });
  }
  openToast(i18n.t('toast.baseProfileCannotBeDeleted'), TOAST_TYPE.ERROR);
  return TOAST_TYPE.ERROR;
}

export function changeSettings(id, newValue) {
  return axios.post(`/settings/change/?id=${id}&newValue=${newValue}`).then((response) => {
    if (response.data.success) {
      return TOAST_TYPE.SUCCESS;
    }

    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}

export function setUserDep(id, groupId) {
  return axios.post(`/settings/setUserDep/?id=${id}&groupId=${groupId}`).then((response) => {
    if (!response.data.success) {
      openToast(response.data.message, TOAST_TYPE.ERROR);
    }
  });
}

export function setDepParent(id, parentId) {
  return axios.post(`/settings/setDepParent/?id=${id}&parentId=${parentId}`).then((response) => {
    if (!response.data.success) {
      openToast(response.data.message, TOAST_TYPE.ERROR);
    }
  });
}

export function deleteUser(id) {
  return axios.post(`/settings/deleteUser/?id=${id}`).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.userSuccessfullyDeleted'));
    } else {
      openToast(response.data.message, TOAST_TYPE.ERROR);
    }
  });
}

export function deleteGroup(id, depOnly) {
  return axios.post(`/settings/deleteGroup/?id=${id}&depOnly=${depOnly}`).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.groupSuccessfullyDeleted'));
    } else {
      openToast(response.data.message, TOAST_TYPE.ERROR);
    }
  });
}

export function renameUser(id, name) {
  return axios.post(`/settings/renameUser/?id=${id}&name=${name}`).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.usernameSuccessfullyUpdated'));
    } else {
      openToast(response.data.message, TOAST_TYPE.ERROR);
    }
  });
}

export function renameGroup(id, name) {
  return axios.post(`/settings/renameGroup/?id=${id}&name=${name}`).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.groupNameSuccessfullyUpdated'));
    } else {
      openToast(response.data.message, TOAST_TYPE.ERROR);
    }
  });
}

export async function addRemote(compArray) {
  const { data } = await axios.post('/settings/addRemote', { compArray });
  if (data.success) {
    return data.result;
  }
  return TOAST_TYPE.ERROR;
}

export async function addNewUser(displayName, compName) {
  const { data } = await axios.post('/settings/newUser', { name: displayName, compName });
  if (data.success) {
    return data.result;
  }
  return TOAST_TYPE.ERROR;
}

export function addNewGroup(name, id) {
  return axios.post('/settings/newGroup', { name, profileId: id }).then((response) => {
    if (response.data.success) {
      if (response.data.result > 0) {
        openToast(i18n.t('toast.groupSuccessfullyAdded'));
        return TOAST_TYPE.SUCCESS;
      }

      openToast(i18n.t('toast.groupAlreadyExists'), TOAST_TYPE.ERROR);
      return TOAST_TYPE.ERROR;
    }

    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}

export function changeCheckedApps(checkedApps, uncheckedApps, compId, type) {
  return axios.post('/settings/changeCheckedApps', { checkedApps, uncheckedApps, compId, type }).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.programListSuccessfullyUpdated'));
      return TOAST_TYPE.SUCCESS;
    }

    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}

export function saveSettings(
  security,
  acsel,
  settings,
  profileId,
  profileName,
  prodProfile,
  wtProfile,
  neiroSett,
  compoundRules,
) {
  return axios
    .post('/settings/saveSettings', {
      security,
      acsel,
      settings,
      profileId,
      profileName,
      prodProfile,
      wtProfile,
      neiroSett,
      compoundRules,
    })
    .then((response) => {
      if (response.data.success) {
        openToast(i18n.t('toast.settingsSuccessfullySaved'));
        return TOAST_TYPE.SUCCESS;
      }
      openToast(response.data.message, TOAST_TYPE.ERROR);
      return TOAST_TYPE.ERROR;
    });
}

export function getProdProfile(settProfile) {
  return axios.post(`/settings/prodProfile/?id=${settProfile}`).then((response) => {
    if (response.data.success) {
      return response.data;
    }
    return response.data.message;
  });
}

export function getProdGroups(profile) {
  return axios.post(`/settings/prodGroups/?id=${profile}`).then((response) => {
    if (response.data.success) {
      return response.data;
    }
    return response.data.message;
  });
}

export function saveProdGroups(appsToAdd, appsToDelete, webToAdd, webToDelete, profile) {
  return axios
    .post('/settings/saveProdGroups', { appsToAdd, appsToDelete, webToAdd, webToDelete, profile })
    .then((response) => {
      if (response.data.success) {
        openToast(i18n.t('toast.changesSuccessfullySaved'));
        return TOAST_TYPE.SUCCESS;
      }
      openToast(response.data.message, TOAST_TYPE.ERROR);
      return TOAST_TYPE.ERROR;
    });
}

export function addProdProfile(name) {
  return axios.post(`/settings/addProdProfile/?name=${name}`).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.profileSuccessfullyAdded'));
      return TOAST_TYPE.SUCCESS;
    }

    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}

export function deleteProdProfile(id) {
  if (id !== 1) {
    return axios.post(`/settings/delProdprofile/?id=${id}`).then((response) => {
      if (response.data.success) {
        openToast(i18n.t('toast.profileSuccessfullyDeleted'));
      } else {
        openToast(response.data.message, TOAST_TYPE.ERROR);
      }
    });
  }
  openToast(i18n.t('toast.baseProfileCannotBeDeleted'), TOAST_TYPE.ERROR);
  return TOAST_TYPE.ERROR;
}

export function setProdProfile(settProfile, prodProfile) {
  return axios
    .post(`/settings/setProdProfile/?settProfile=${settProfile}&prodProfile=${prodProfile}`)
    .then((response) => {
      if (response.data.success) {
        openToast(i18n.t('toast.profileSuccessfullyUpdated'));
        return TOAST_TYPE.SUCCESS;
      }
      openToast(response.data.message, TOAST_TYPE.ERROR);
      return TOAST_TYPE.ERROR;
    });
}

export function getWtProfile(settProfile) {
  return axios.post(`/settings/wtProfile/?id=${settProfile}`).then((response) => {
    if (response.data.success) {
      return response.data;
    }
    return response.data.message;
  });
}

export function addWtProfile(name) {
  return axios.post(`/settings/addWtProfile/?name=${name}`).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.profileSuccessfullyAdded'));
      return TOAST_TYPE.SUCCESS;
    }

    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}

export function deleteWtProfile(id) {
  if (id !== 1) {
    return axios.post(`/settings/delWtprofile/?id=${id}`).then((response) => {
      if (response.data.success) {
        openToast(i18n.t('toast.profileSuccessfullyDeleted'));
      } else {
        openToast(response.data.message, TOAST_TYPE.ERROR);
      }
    });
  }
  openToast(i18n.t('toast.baseProfileCannotBeDeleted'), TOAST_TYPE.ERROR);
  return TOAST_TYPE.ERROR;
}

export function setWtProfile(settProfile, wtProfile) {
  return axios.post(`/settings/setWtProfile/?settProfile=${settProfile}&wtProfile=${wtProfile}`).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.profileSuccessfullyUpdated'));
      return TOAST_TYPE.SUCCESS;
    }
    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}

export function getLinksContact(id, compName, name, isContact = false) {
  return axios
    .post('/settings/getLinksContact', {
      id,
      compName,
      name,
      isContact,
    })
    .then((response) => {
      if (response.data.success) {
        return response.data;
      }
      return response.data.message;
    });
}

export function getLinkContactFromRelations(id, cid) {
  return axios.post(`/settings/getLinkContactFromRelations/?id=${id}&cid=${cid}`).then((response) => {
    if (response.data.success) {
      return response.data;
    }
    return response.data.message;
  });
}

export function deleteContact(id) {
  return axios.post(`/settings/deleteContact/?id=${id}`).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.contactSuccessfullyDeleted'));
    } else {
      openToast(response.data.message, TOAST_TYPE.ERROR);
    }
  });
}

export function addContact(compName, name, details, comment) {
  return axios
    .post(`/settings/addContact/?compName=${compName}&name=${name}&details=${details}&comment=${comment}`)
    .then((response) => {
      if (response.data.success) {
        openToast(i18n.t('toast.contactSuccessfullyAdded'));
        return response.data;
      }
      openToast(response.data.message, TOAST_TYPE.ERROR);
      return response.data.message;
    });
}

export function addContactMsgr(contactId, type, login, nickname) {
  return axios
    .post(`/settings/addContactMsgr/?contactId=${contactId}&type=${type}&login=${login}&nickname=${nickname}`)
    .then((response) => {
      if (response.data.success) {
        openToast(i18n.t('toast.contactSuccessfullyLinked'));
        return response.data;
      }
      openToast(response.data.message, TOAST_TYPE.ERROR);
      return response.data.message;
    });
}

export function deleteContactMsgr(id) {
  return axios.post(`/settings/deleteContactMsgr/?id=${id}`).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.msgrSuccessfullyDeleted'));
    } else {
      openToast(response.data.message, TOAST_TYPE.ERROR);
    }
  });
}

export function editContactMsgr(id, login) {
  return axios.post(`/settings/editContactMsgr/?id=${id}&login=${login}`).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.msgrSuccessfullyEdited'));
      return TOAST_TYPE.SUCCESS;
    }
    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}
export function saveContactInfo(id, person, type) {
  return axios
    .post(`/settings/saveContactInfo/?id=${id}&person=${person}&type=${type}`, { id, person, type })
    .then((response) => {
      if (response.data.success) {
        openToast(i18n.t('toast.dataSavedSuccessfully'));
        return TOAST_TYPE.SUCCESS;
      }
      openToast(response.data.message, TOAST_TYPE.ERROR);
      return TOAST_TYPE.ERROR;
    });
}

export function addVacation(contactId, startTime, endTime) {
  return axios
    .post(`/settings/addVacation/?contactId=${contactId}&startTime=${startTime}&endTime=${endTime}`)
    .then((response) => {
      if (response.data.success) {
        return response.data;
      }
      return response.data.message;
    });
}
export function deleteVacation(id) {
  return axios.post(`/settings/deleteVacation/?id=${id}`).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.vacationSuccessfullyDeleted'));
    } else {
      openToast(response.data.message, TOAST_TYPE.ERROR);
    }
  });
}

export function getWorktime(wtProfile) {
  return axios.post(`/settings/worktime/?wtProfile=${wtProfile}`).then((response) => {
    if (response.data.success) {
      return response.data;
    }
    return response.data.message;
  });
}

export function saveWorktime(toDelete, toAdd) {
  return axios.post('/settings/saveWorktime', { toDelete, toAdd }).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.changesSuccessfullySaved'));
      return TOAST_TYPE.SUCCESS;
    }
    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}

export function changeCalendar(profId, useCalendar) {
  return axios.post('/settings/changeWtCalendar', { profId, useCalendar }).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.changesSuccessfullySaved'));
      return TOAST_TYPE.SUCCESS;
    }
    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}

export function addAcselParams(profId, val, sval) {
  return axios.post(`/settings/addAcselParams/?profId=${profId}&val=${val}`, { sval }).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.pathSuccessfullyAdded'));
      return TOAST_TYPE.SUCCESS;
    }
    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}

export function delAcselParams(id) {
  return axios.post(`/settings/delAcselParams/?id=${id}`).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.pathSuccessfullyDeleted'));
      return TOAST_TYPE.SUCCESS;
    }
    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}

export function editAcselParams(id, val, sval) {
  return axios.post(`/settings/editAcselParams/?id=${id}&val=${val}`, { sval }).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.pathSuccessfullyEdited'));
      return TOAST_TYPE.SUCCESS;
    }
    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}

export function getSerials(compId) {
  return getSettings(`/settings/serials/?compId=${compId}`);
}

export function setSerial(compId, usbArray) {
  return axios.post(`/settings/setSerial/?compId=${compId}`, { usbArray }).then((response) => {
    if (response.data.success) {
      if (usbArray.length === 1) openToast(i18n.t('toast.deviceSuccessfullyAdded'));
      if (usbArray.length > 1) openToast(i18n.t('toast.devicesSuccessfullyAdded'));
      return TOAST_TYPE.SUCCESS;
    }
    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}

export function setSerialForProfile(profId, usbArray) {
  return axios.post(`/settings/setSerialProfile/?profId=${profId}`, { usbArray }).then((response) => {
    if (response.data.success) {
      if (usbArray.length === 1) openToast(i18n.t('toast.deviceSuccessfullyAdded'));
      if (usbArray.length > 1) openToast(i18n.t('toast.devicesSuccessfullyAdded'));
      return TOAST_TYPE.SUCCESS;
    }
    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}

export function setSerialForAll(usbArray) {
  return axios.post('/settings/setSerialAll/', { usbArray }).then((response) => {
    if (response.data.success) {
      if (usbArray.length === 1) openToast(i18n.t('toast.deviceSuccessfullyAdded'));
      if (usbArray.length > 1) openToast(i18n.t('toast.devicesSuccessfullyAdded'));
      return TOAST_TYPE.SUCCESS;
    }
    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}

export function removeSerial(usbArray) {
  return axios.post('/settings/removeSerial/', { usbArray }).then((response) => {
    if (response.data.success) {
      if (usbArray.length === 1) openToast(i18n.t('toast.deviceSuccessfullyRemovedFromList'));
      if (usbArray.length > 1) openToast(i18n.t('toast.devicesSuccessfullyRemovedFromList'));
      return TOAST_TYPE.SUCCESS;
    }
    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}

export function removeSerialForAll(usbArray) {
  return axios.post('/settings/removeSerialAll/', { usbArray }).then((response) => {
    if (response.data.success) {
      if (usbArray.length === 1) openToast(i18n.t('toast.deviceSuccessfullyRemovedFromList'));
      if (usbArray.length > 1) openToast(i18n.t('toast.devicesSuccessfullyRemovedFromList'));
      return TOAST_TYPE.SUCCESS;
    }
    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}

export function delSerial(usbArray) {
  return axios.post('/settings/delSerial/', { usbArray }).then((response) => {
    if (response.data.success) {
      if (usbArray.length === 1) openToast(i18n.t('toast.deviceSuccessfullyDeleted'));
      if (usbArray.length > 1) openToast(i18n.t('toast.devicesSuccessfullyDeleted'));
      return TOAST_TYPE.SUCCESS;
    }
    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}

export function editComment(id, comment) {
  return axios.post(`/settings/editComment/?id=${id}`, { comment }).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.commentSuccessfullySaved'));
      return TOAST_TYPE.SUCCESS;
    }
    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}

export function addSerial(usbArray) {
  return axios.post('/settings/addSerial/', { usbArray }).then((response) => {
    if (response.data.success) {
      openToast(
        i18n.t('toast.devicesAdded', { added: response.data.result.added, skipped: response.data.result.skipped }),
      );
      return TOAST_TYPE.SUCCESS;
    }
    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}

export function getExceptions(id, type) {
  return axios.post(`/settings/exceptions/?id=${id}?type=${type}`).then((response) => {
    if (response.data.success) {
      return response.data;
    }
    return response.data.message;
  });
}

export function editExceptions(profile, exceptions, stype) {
  return axios.post(`/settings/editExceptions/?profile=${profile}&stype=${stype}`, { exceptions }).then((response) => {
    if (response.data.success) {
      if (stype === 2) openToast(i18n.t('toast.applicationsListSuccessfullySaved'));
      if (stype === 3) openToast(i18n.t('toast.websitesListSuccessfullySaved'));
      return TOAST_TYPE.SUCCESS;
    }
    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}

export function getAcselParams(id, type) {
  return getSettings(`/settings/acselParams/?id=${id}&type=${type}`);
}

export function saveGeneralSettings(changed) {
  return axios.post('/settings/saveGeneral/', { changed }).then((response) => {
    if (response.data.success) {
      openToast(i18n.t('toast.settingsSuccessfullySaved'));
      return TOAST_TYPE.SUCCESS;
    }
    openToast(response.data.message, TOAST_TYPE.ERROR);
    return TOAST_TYPE.ERROR;
  });
}

export const getDiagnosticsData = (date) => axios.get(`/settings/diagnostics/?date=${date}`);

export function changeAgentPassword(id, password, username, compname) {
  axios.post(`/settings/changeAgentPassword/?id=${id}`, {
    password,
    username,
    compname,
  });
}

export function changeUserPassword(id, username, compname) {
  axios.post(`/settings/changeUserPassword/?id=${id}`, {
    username,
    compname,
  });
}

export function changeCompMac(id, username, compname) {
  axios.post(`/settings/changeCompMac/?id=${id}`, {
    username,
    compname,
  });
}

export const getSysLogs = (type, dateFrom, dateTo) =>
  axios.post('/settings/sysLogs', { type, dateFrom, dateTo }).then((response) => {
    if (response.data.success) {
      return response.data.result;
    }
    return 'error';
  });
